// extracted by mini-css-extract-plugin
module.exports = {"row":"SimpleQuestionBuilderModal_row__3p2b5","radioRow":"SimpleQuestionBuilderModal_radioRow__31dF-"};